import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { AdminService } from '../../../_services/admin.service';
import { ProductType } from '../../../_models/producttype';
import { ACLFeature } from '../../../_models/acl-feature';
import { Permissions } from '../../../_services/permissions';
import * as FileSaver from 'file-saver';

@Component({
    selector: 'edit-download-catalog',
    styleUrls: ['catalog.less'],
    templateUrl: 'catalog.component.html',
})
export class CatalogComponent implements OnInit, OnDestroy {

    productType: ProductType = ProductType.create(1, 'module');

    uploadError = '';
    showModuleSuccessMessage = false;
    showDriverSuccessMessage = false;

    iCanMaintenanceMode = false;
    iCanExportDrivers = false;
    iCanExportModules = false;

    @Input() regions: Array<string>;
    @Input() driverGroups: Array<string>;
    @Input() driverType: string;

    constructor(
        private admin: AdminService,
        private permissions: Permissions
    ) {}

    ngOnInit() {

      this.permissions.hasFeature(ACLFeature.MAINTENANCE_MODE_ADMIN)
        .subscribe((success) => {
          this.iCanMaintenanceMode = success;
        });

      this.permissions.hasFeature(ACLFeature.EXPORT_EXCEL_REGIONIZED_DRIVER_PORTFOLIO)
        .subscribe((success) => {
          this.iCanExportDrivers = success;
        });

      this.permissions.hasFeature(ACLFeature.EXPORT_EXCEL_REGIONIZED_MODULE_PORTFOLIO)
        .subscribe((success) => {
          this.iCanExportModules = success;
        });
    }

    onDriverTypeChange(event) {
        this.driverType = event.text;
    }

    downloadCatalog(region: string, productType: string, maintenanceMode: boolean) {
        if (productType === 'driver') {
            this.uploadError = '';

            if (!this.driverType || this.driverType.length < 1) {
                this.uploadError = 'Please choose a driver type!';
                return;
            }
            this.showDriverSuccessMessage = true;
        } else {
            this.showModuleSuccessMessage = true;
        }


        this.admin.downloadCatalog(region, productType, this.driverType, maintenanceMode).subscribe((res) => {
            //noinspection TypeScriptUnresolvedFunction
            FileSaver.saveAs(res, `${productType}-${region}-catalog.xlsx`);
            this.showModuleSuccessMessage = false;
            this.showDriverSuccessMessage = false;
        });
    }

    ngOnDestroy() {
    }
}



// WEBPACK FOOTER //
// ./src/app/management/components/catalog/catalog.component.ts